import React, { useRef, useEffect, useState } from "react";
import styles from "./ReviewMain.module.css";

import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";

import { useHistory, Link } from "react-router-dom";

import { connect } from "react-redux";
import changePassportDetails from "../../../store/Actions/PassportDetailsAction";

import Radio from "@material-ui/core/Radio";
import document from "../../../assets/images/document.svg";

import { ApplicationByIdApi } from "../../../config/ApplicationByIdApi";
import { submitDetailsApi } from "../../../config/submitDetailsApi";

function ReviewMain(props) {
  useEffect(() => {
    if (props.passportDetails.application !== true) {
      history.push("/dashboard/my-applications");
    }
    else if(props.passportDetails.passport_type === undefined || props.passportDetails.passport_type === null || props.passportDetails.passport_type === ""){
      history.push("/dashboard/my-applications");
    }
    else {
      setId(props.passportDetails.id);
      setPassportType(props.passportDetails.passport_type);
      setGivenName(
        props.passportDetails.first_name,
        " " + props.passportDetails.given_name
      );
      setSurName(props.passportDetails.last_name);
      setCountryOfBirth(props.passportDetails.country_of_birth);
      setDateOfBirthDate(props.passportDetails.date_of_birth_date);
      setDateOfBirthMonth(props.passportDetails.date_of_birth_month);
      setDateOfBirthYear(props.passportDetails.date_of_birth_year);
      setPassportIssuanceDate(
        props.passportDetails.passport_issuance_date_date
      );
      setPassportIssuanceMonth(
        props.passportDetails.passport_issuance_date_month
      );
      setPassportIssuanceYear(
        props.passportDetails.passport_issuance_date_year
      );
      setPassportExpiryDate(props.passportDetails.passport_expiry_date_date);
      setPassportExpiryMonth(props.passportDetails.passport_expiry_date_month);
      setPassportExpiryYear(props.passportDetails.passport_expiry_date_year);
      setNationality(props.passportDetails.nationality);
      setPassportIssuancePlace(props.passportDetails.passport_issuance_place);
      setSex(props.passportDetails.gender);
      setPassportNumber(props.passportDetails.passport_number);
      setPlaceOfBirth(props.passportDetails.place_of_birth);

      setMaritalStatus(props.passportDetails.marital_status);
      setProfession(props.passportDetails.profession);
      setReligion(props.passportDetails.religion);
      setHusbandName(props.passportDetails.husbands_name);
      setWifeName(props.passportDetails.wifes_name);
      setMotherName(props.passportDetails.mothers_name);
      setFatherName(props.passportDetails.fathers_name);

      setArrivalCity(props.passportDetails.arrival_city);
      setDepartureCity(props.passportDetails.departure_city);
      setBooked(props.passportDetails.is_ticket_booked);
      setDepartureAirlineName(props.passportDetails.departure_airline);
      setArrivalDate(props.passportDetails.arrival_date_date);
      setArrivalMonth(props.passportDetails.arrival_date_month);
      setArrivalYear(props.passportDetails.arrival_date_year);
      setDepartureDate(props.passportDetails.departure_date_date);
      setDepartureMonth(props.passportDetails.departure_date_month);
      setDepartureYear(props.passportDetails.departure_date_year);

      setFormId(props.passportDetails.document_id)

      function getWithExpiry(key) {
        const itemStr = localStorage.getItem(key);
        if (!itemStr) {
          return null;
        }

        const item = JSON.parse(itemStr);
        const now = new Date();

        if (now.getTime() > item.expiry) {
          localStorage.removeItem(key);
          console.log("REMOVE");
          return null;
        }
        setToken(item.value.token);

        const application = async (token) => {
          const getApplication = await ApplicationByIdApi(
            token,
            props.passportDetails.id
          );

          if (getApplication.data) {
            console.log(getApplication.data)

            setCount(getApplication.data.data.travellers_count);
            setInfo(getApplication.data.data.travellers_informations.length  + 1)
            console.log(getApplication.data)
            if(getApplication.data.data.travellers_count === getApplication.data.data.travellers_informations.length + 1){
              console.log("Thankyou")
            }
            else if(getApplication.data.data.travellers_informations.length > getApplication.data.data.travellers_count){
              console.log("Too Many Submitted")
            }
            else{
               console.log("Traveller page")
            }
            setDocs(getApplication.data.data.documents);
            setLoading1(false);
          } else if (getApplication.error) {
            console.log(getApplication.error);
          }
        };
        application(item.value.token);
      }
      getWithExpiry("userData");
    }
  }, []);

  const history = useHistory();
  const [id, setId] = useState("");
  const [formId, setFormId] = useState("")
  const [passportType, setPassportType] = useState("");
  const [surName, setSurName] = useState("");
  const [givenName, setGivenName] = useState("");
  const [countryOfBirth, setCountryOfBirth] = useState("");
  const [dateOfBirthDate, setDateOfBirthDate] = useState("");
  const [dateOfBirthMonth, setDateOfBirthMonth] = useState("");
  const [dateOfBirthYear, setDateOfBirthYear] = useState("");
  const [passportNumber, setPassportNumber] = useState("");
  const [passportIssuancePlace, setPassportIssuancePlace] = useState("");
  const [passportIssuanceDate, setPassportIssuanceDate] = useState("");
  const [passportIssuanceMonth, setPassportIssuanceMonth] = useState("");
  const [passportIssuanceYear, setPassportIssuanceYear] = useState("");
  const [passportExpiryDate, setPassportExpiryDate] = useState("");
  const [passportExpiryMonth, setPassportExpiryMonth] = useState("");
  const [passportExpiryYear, setPassportExpiryYear] = useState("");
  const [placeOfBirth, setPlaceOfBirth] = useState("");
  const [nationality, setNationality] = useState("");
  const [sex, setSex] = useState("");

  const [maritalStatus, setMaritalStatus] = useState("");
  const [profession, setProfession] = useState("");
  const [religion, setReligion] = useState("");
  const [husbandName, setHusbandName] = useState("");
  const [wifeName, setWifeName] = useState("");
  const [motherName, setMotherName] = useState("");
  const [fatherName, setFatherName] = useState("");

  const [arrivalCity, setArrivalCity] = useState("");
  const [departureCity, setDepartureCity] = useState("");
  const [booked, setBooked] = useState("");
  const [departureAirlineName, setDepartureAirlineName] = useState("");
  const [arrivalDate, setArrivalDate] = useState("");
  const [arrivalMonth, setArrivalMonth] = useState("");
  const [arrivalYear, setArrivalYear] = useState("");
  const [departureDate, setDepartureDate] = useState("");
  const [departureMonth, setDepartureMonth] = useState("");
  const [departureYear, setDepartureYear] = useState("");

  const [docs, setDocs] = useState([]);
  const [loading1, setLoading1] = useState(true);

  const [token, setToken] = useState("");
  const [loading2, setLoading2] = useState(false);

  const [count, setCount] = useState("")
  const [info, setInfo] = useState("")

  const editPassportDetails = () => {
    history.push(`/dashboard/my-applications/${id}/passport-info`);
  };
  const editOtherDetails = () => {
    history.push(`/dashboard/my-applications/${id}/other-info`);
  };
  const editTravelDetails = () => {
    history.push(`/dashboard/my-applications/${id}/travel-info`);
  };


  const data = props.passportDetails;
  const one = [
    "application",
    "id",
    'first_name',
    'middle_name',
    "passport_issuance_date_date",
    "passport_issuance_date_month",
    "passport_issuance_date_year",
    "passport_expiry_date_date",
    "passport_expiry_date_month",
    "passport_expiry_date_year",
    "date_of_birth_date",
    "date_of_birth_month",
    "date_of_birth_year",
    "arrival_date_date",
    "arrival_date_month",
    "arrival_date_year",
    "departure_date_date",
    "departure_date_month",
    "departure_date_year",
    "document_id",
  ];
 
  const newdata = Object.keys(data).reduce((object, key) => {
    if (!one.includes(key)) {
      object[key] = data[key];
    }
    return object;
  }, {});


    if(props.passportDetails.marital_status !== "MARRIED" ){
    delete newdata.wifes_name
    delete newdata.husbands_name
    delete newdata.spouse_name
    }
    else{
      delete newdata.wifes_name
      delete newdata.husbands_name
    }

    if(props.passportDetails.departure_city === ""){
      delete newdata.departure_city
    }
    if(props.passportDetails.arrival_city === ""){
      delete newdata.arrival_city
    }
    if(props.passportDetails.departure_date === ""){
      delete newdata.departure_date
    }
    if(props.passportDetails.arrival_date === ""){
      delete newdata.arrival_date
    }
    if(props.passportDetails.departure_airline === ""){
      delete newdata.departure_airline
    }

  
  newdata.given_name = props.passportDetails.first_name + " " + props.passportDetails.middle_name
  newdata.status = "COMPLETED"

  console.log(newdata);
  console.log(props.passportDetails.document_id)

  const submit = () => {
    setLoading2(true);

    const submitApplication = async () => {
      const SubmitApp = await submitDetailsApi(id, token, newdata, formId);

      if (SubmitApp.data) {
        console.log(SubmitApp.data);

        if(count === info){
          history.push(`/dashboard/my-applications/${id}/submitted-successfully`);
        }
        else{
          history.push(`/dashboard/my-applications/${id}/travellers`);
        }
        setLoading2(false);
      } else if (SubmitApp.error) {
        toast.error(
          <span style={{ display: "flex", alignItems: "center" }}>
            <BiError size="22" />
            &nbsp; {SubmitApp.error.message}
          </span>,
          {
            position: "bottom-left",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
        console.log("Too Many Submissions")
        setLoading2(false);
      }
    };
    submitApplication();
  };

  const submitLater = () => {
    console.log("Submit Later");
    history.push(`/dashboard/my-applications/${id}/travellers`);
  };

  return (
    <div>
      <h2 className={styles.head}>Application Form</h2>
      <div className={styles.mainBox}>
        <div className={styles.box1FirstCont}>
          <p className={styles.badge}>1</p>
          <p className={styles.FirstText}>Passport Information</p>
        </div>
        <hr className={styles.line} />
        <div className={styles.inputsBox}>
          <div>
            <label for="passport-type" className={styles.label}>
              Passport Type
            </label>
            <br />
            <span type="text" id="passport-type" className={styles.input}>
              {passportType}
            </span>
          </div>
          <div>
            <label for="Surname" className={styles.label}>
              Surname<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span type="text" id="Surname" className={styles.input}>
              {surName}
            </span>
          </div>
          <div>
            <label for="Given-Name" className={styles.label}>
              Given Name<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span type="text" id="Given-Name" className={styles.input}>
              {givenName}
            </span>
          </div>
        </div>
        <div className={styles.inputsBox}>
          <div>
            <label for="Country-of-Birth" className={styles.label}>
              Country of Birth<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span type="text" id="Country-of-Birth" className={styles.input}>
              {countryOfBirth}
            </span>
          </div>
          <div>
            <label for="Date of Birth" className={styles.label}>
              Date of Birth<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span className={styles.input2}>
              <span
                type="number"
                className={styles.inputIn}
                min="1"
                max="31"
                maxLength="2"
              >
                {dateOfBirthDate}
              </span>
              <span
                type="number"
                className={styles.inputIn}
                min="1"
                max="12"
                maxLength="2"
              >
                {dateOfBirthMonth}
              </span>
              <span type="number" className={styles.inputIn2} maxLength="2">
                {dateOfBirthYear}
              </span>
            </span>
          </div>
          <div>
            <label for="Place of birth" className={styles.label}>
              Place of birth<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span type="text" id="Place of birth" className={styles.input}>
              {placeOfBirth}
            </span>
          </div>
        </div>
        <div className={styles.inputsBox}>
          <div>
            <label for="Passport Number" className={styles.label}>
              Passport Number<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span
              type="text"
              id="Passport Number"
              type="text"
              className={styles.input}
            >
              {passportNumber}
            </span>
          </div>
          <div>
            <label for="Passport Issuance Date" className={styles.label}>
              Passport Issuance Date<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span className={styles.input2}>
              <span
                type="number"
                className={styles.inputIn}
                min="1"
                max="31"
                maxLength="2"
              >
                {passportIssuanceDate}
              </span>
              <span
                type="number"
                className={styles.inputIn}
                min="1"
                max="12"
                maxLength="2"
              >
                {passportIssuanceMonth}
              </span>
              <span type="number" className={styles.inputIn2} maxLength="2">
                {passportIssuanceYear}
              </span>
            </span>
          </div>
          <div>
            <label for="Passport Expiry Date" className={styles.label}>
              Passport Expiry Date<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span className={styles.input2}>
              <span type="number" className={styles.inputIn}>
                {passportExpiryDate}
              </span>
              <span type="number" className={styles.inputIn}>
                {passportExpiryMonth}
              </span>
              <span type="number" className={styles.inputIn2}>
                {passportExpiryYear}
              </span>
            </span>
          </div>
        </div>
        <div className={styles.inputsBox}>
          <div>
            <label for="Nationality" className={styles.label}>
              Nationality<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span type="text" id="Nationality" className={styles.input}>
              {nationality}
            </span>
          </div>
          <div>
            <label for="Passport Issuance Place" className={styles.label}>
              Passport Issuance Place<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span
              type="text"
              id="Passport Issuance Place"
              className={styles.input}
            >
              {passportIssuancePlace}
            </span>
          </div>
          <div>
            <label for="Sex" className={styles.label}>
              Sex<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span type="text" id="Sex" className={styles.input}>
              {sex}
            </span>
          </div>
        </div>
        <div className={styles.btns}>
          <button className={styles.btn1} onClick={() => editPassportDetails()}>
            Edit Passport Details
          </button>
        </div>
      </div>
      <br />
      <div className={styles.mainBox2}>
        <div className={styles.box1FirstCont}>
          <p className={styles.badge}>2</p>
          <p className={styles.FirstText}>Other Information</p>
        </div>
        <hr className={styles.line} />
        <div className={styles.inputsBox}>
          <div className={styles.select}>
            <label for="Profession" className={styles.label}>
              Marital Status
            </label>
            <br />

            <span className={styles.input}>{maritalStatus}</span>
          </div>
          <div className={styles.select}>
            <label for="Profession" className={styles.label}>
              Profession
            </label>
            <br />
            <span className={styles.input}>{profession}</span>
          </div>

          <div className={styles.select}>
            <label for="Religion" className={styles.label}>
              Religion
            </label>
            <br />
            <span className={styles.input}>{religion}</span>
          </div>
        </div>

        <div className={styles.inputsBox}>
          {maritalStatus === "MARRIED" ? (
            sex === "MALE" ? (
              <div>
                <label for="Wife's Name" className={styles.label}>
                  Wife's Name
                </label>
                <br />
                <span className={styles.input}>{wifeName}</span>
              </div>
            ) : sex === "FEMALE" ? (
              <div>
                <label for="Husband's Name" className={styles.label}>
                  Husband's Name
                </label>
                <br />
                <span className={styles.input}>{husbandName}</span>
              </div>
            ) : null
          ) : null}

          <div>
            <label for="Mother's Name" className={styles.label}>
              Mother's Name
            </label>
            <br />
            <span className={styles.input}>{motherName}</span>
          </div>
          <div>
            <label for="Father's Name" className={styles.label}>
              Father's Name
            </label>
            <br />
            <span className={styles.input}>{fatherName}</span>
          </div>
        </div>
        <div className={styles.btns}>
          <button className={styles.btn1} onClick={() => editOtherDetails()}>
            Edit Other Details
          </button>
        </div>
      </div>
      <br />

      <div className={(booked === "YES") ? (styles.mainBox3) : (styles.mainBox3Diff)  } >
        <div className={styles.box1FirstCont}>
          <p className={styles.badge}>3</p>
          <p className={styles.FirstText}>Travel Information</p>
        </div>
        <hr className={styles.line} />
        <div className={styles.inputsBox1}>
          <div>
            <label
              for="Have you booked your flight tickets?"
              className={styles.label}
            >
              Have you booked your flight tickets?
            </label>
            <br />
            <span>
              <span>
                <Radio
                  // onChange={() => {
                  //   setBooked("YES")
                  // }}
                  checked={booked === "YES"}
                  value="normal"
                  color="default"
                  name="Booked"
                  disabled={true}
                />
                Yes
              </span>
              <span className={styles.littleMar}>
                <Radio
                  // onChange={() => {
                  //     setBooked("NO")
                  // }}
                  checked={booked === "NO"}
                  value="No"
                  color="default"
                  name="Booked"
                  disabled={true}
                />
                No
              </span>
            </span>
          </div>
        </div>
        {(booked === 'YES')?(
          <>
          <div className={styles.inputsBox}>
          <div>
            <label for="Departure City" className={styles.label}>
              Departure City<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span className={styles.input}>{departureCity}</span>
          </div>
          <div>
            <label for="Arrival City" className={styles.label}>
              Arrival City<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span className={styles.input}>{arrivalCity}</span>
          </div>
          <div>
            <label for="Departure Airline Name" className={styles.label}>
              Departure Airline Name<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span className={styles.input}>{departureAirlineName}</span>
          </div>
        </div>
        <div className={styles.inputsBox}>
          <div>
            <label for="Departure Date" className={styles.label}>
              Departure Date<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span className={styles.input2}>
              <span className={styles.input2}>
                <span type="number" className={styles.inputIn}>
                  {departureDate}
                </span>
                <span type="number" className={styles.inputIn}>
                  {departureMonth}
                </span>
                <span type="number" className={styles.inputIn2}>
                  {departureYear}
                </span>
              </span>
            </span>
          </div>
          <div>
            <label for="Arrival Date" className={styles.label}>
              Arrival Date<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span className={styles.input2}>
              <span type="number" className={styles.inputIn}>
                {arrivalDate}
              </span>
              <span type="number" className={styles.inputIn}>
                {arrivalMonth}
              </span>
              <span type="number" className={styles.inputIn2}>
                {arrivalYear}
              </span>
            </span>
          </div>
        </div>
          </>
        ):(null)}
        <div className={styles.btns}>
          <button className={styles.btn1} onClick={() => editTravelDetails()}>
            Edit Travel Details
          </button>
        </div>
      </div>
      <br />
      <div className={styles.mainBox4}>
        <div className={styles.box1FirstCont}>
          <p className={styles.badge}>4</p>
          <p className={styles.FirstText}>Uploaded Documents</p>
        </div>
        <hr className={styles.line} />
        <div className={styles.container}>
          <h1 className={styles.attachmentHead}>Attachments:</h1>

          <div className={styles.documents}>
            {loading1 ? (
              <div className={styles.loader1}>
                <div className="spinner-border" role="status"></div>
              </div>
            ) : (
              docs.map((value, index) => (
                <div className={styles.document} key={index}>
                  <a href={value.link} target="_blank" rel="noopener">
                    <img
                      src={document}
                      alt="Documents"
                      className={styles.documentimage}
                    />
                  </a>
                  <a href={value.link} target="_blank" rel="noopener">
                    <h1 className={styles.documentName}>{value.name}</h1>
                  </a>
                </div>
              ))
            )}
          </div>
          <Link to={`/dashboard/my-applications/${id}/upload-other-docs`}>
            <button className={styles.UploadMore}>Upload More</button>
          </Link>
        </div>
        <div className={styles.btnsCont}>
          <button className={styles.btn1} onClick={() => submitLater()}>
            Save and submit later
          </button>
          <button className={styles.btn2} onClick={() => submit()}>
            {loading2 ? (
              <div className="spinner-border" role="status"></div>
            ) : (
              "Submit"
            )}
          </button>
        </div>
        {/* <div className={styles.inputsBox}>
          <div>
            <label for="passport-type" className={styles.label}>
              Passport Type
            </label>
            <br /> 
            <span type="text" id="passport-type" className={styles.input}>
              {passportType}
            </span>
          </div>
          <div>
            <label for="Surname" className={styles.label}>
              Surname<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span type="text" id="Surname" className={styles.input}>
              {surName}
            </span>
          </div>
          <div>
            <label for="Given-Name" className={styles.label}>
              Given Name<span style={{ color: "#d84343" }}>*</span>
            </label>
            <br />
            <span type="text" id="Given-Name" className={styles.input}>
              {givenName}
            </span>
          </div>
        </div> */}
      </div>

      <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        className={styles.toasst}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  passportDetails: state.PassportDetails.passportDetails,
});

const mapDispatchToProp = (dispatch) => ({
  ChangePassportDetails: (passportDetails) =>
    dispatch(changePassportDetails(passportDetails)),
});

export default connect(mapStateToProps, mapDispatchToProp)(ReviewMain);
